<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customer_addresses.address_name_placeholder")' :danger="$v.form.address_name.$invalid && $v.form.address_name.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.address_name') })" v-model="form.address_name" :label='$t("customer_addresses.address_name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.street_name_placeholder")' :danger="$v.form.street_name.$invalid && $v.form.street_name.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.street_name') })" v-model="form.street_name" :label='$t("customer_addresses.street_name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.street_number_placeholder")' :danger="$v.form.street_number.$invalid && $v.form.street_number.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.street_number') })" v-model="form.street_number" :label='$t("customer_addresses.street_number")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.city_placeholder")' :danger="$v.form.city.$invalid && $v.form.city.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.city') })" v-model="form.city" :label='$t("customer_addresses.city")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.state_placeholder")' :danger="$v.form.state.$invalid && $v.form.state.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.state') })" v-model="form.state" :label='$t("customer_addresses.state")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.country_placeholder")' :danger="$v.form.country.$invalid && $v.form.country.$model" :danger-text="$t('validation.required', { attribute: $t('customer_addresses.country') })" v-model="form.country" :label='$t("customer_addresses.country")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("customer_addresses.zip_code_placeholder")' :danger="$v.form.zip_code.$invalid && $v.form.zip_code.$model" :danger-text="$v.form.zip_code.maxLength ? $v.form.zip_code.required ? '' : $t('validation.required', { attribute: $t('customer_addresses.zip_code') }) : $t('validation.max.string', { attribute: $t('customer_addresses.zip_code'), max: 5 })" v-model="form.zip_code" :label='$t("customer_addresses.zip_code")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, maxLength } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('CustomerAddresses')

export default {
  name: 'ModalCustomerAddresses',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        address_name: {
          required
        },
        street_name: {
          required
        },
        street_number: {
          required
        },
        city: {
          required
        },
        state: {
          required
        },
        country: {
          required
        },
        zip_code: {
          required,
          maxLength: maxLength(5)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addRecord({
        ...this.form,
        customer_id: this.$route.params.customerId
      }) : this.editRecord({
        ...this.form,
        customer_id: this.$route.params.customerId
      })
    }
  }
}
</script>
